var { primary, accent, danger, CSS_COLORS, inquirer,
	npmPkg, APP_ROOT, TEMPLATES_ROOT, ROOT_MODULE } = require('../../common.js')
var _ 		= require('lodash')
var chalk 	= require('chalk')
var fs 		= require('fs')
var path 	= require('path')


function startGenerateService(args) {
	// var name = _.kebabCase(args.slice(0, args.length -1).join(' '))
	// var parent = args[args.length - 1]
	var name = capitalize(_.camelCase(args[0]))
	var parent = args[1]

	console.log(accent('ops generate service --'))
	// console.log('')

	// Get name and parent

	var prompts = []

	if (!name) {
		prompts.push({
			type: 'input',
			name: 'name',
			message: 'name:'
		})
	} else {
		console.log(`\tname: ${accent(name)}`)
	}

	if (!parent) {
		prompts.push({
			type: 'list',
			name: 'parent',
			choices: npmPkg.apps.map(app => app.name),
			message: 'parent:'
		})
	} else {
		console.log(`\tparent: ${accent(parent)}`)
	}

	inquirer
		.prompt(prompts)
		.then(function(res) {
			name 	= capitalize(_.camelCase(res.name)) || name   || 'NewService'
			parent 	= res.parent 			|| parent || 'common'
			// console.log('')
			generateService(name, parent)
		})

}


function generateService(name, parent) {

	// Create service folder

	var servicesDirectory = path.join(APP_ROOT, `/${parent}/services/`)
	if (!fs.existsSync(servicesDirectory)) fs.mkdirSync(servicesDirectory)

	// Create service files

	var js = `
angular
	.module('${ROOT_MODULE}')
	.service('${name}', ${name} )

function ${name}( $http ) { "ngInject"


///// BINDABLE METHODS AND PROPERTIES


	${name}.test = test

	return ${name}


///// IMPLEMENTATION DETAILS

	function test() {
		console.log('Hello from ${name}')
	}

}`

	fs.writeFileSync(path.join(servicesDirectory, `${name}.js`), js)

	// Write imports

	var importErrors = false

	var jsImport = `import './${parent}/services/${name}.js'`
	var jsDest = fs.readFileSync(path.join(APP_ROOT, 'webpack.entry.js'), 'utf8')
	var jsRegex = new RegExp(`// ${parent.toUpperCase()}\n`)

	if (jsRegex.test(jsDest)) {
		var jsResult = jsDest.replace(jsRegex, `// ${parent.toUpperCase()}\n\n${jsImport}`)
		fs.writeFileSync(path.join(APP_ROOT, 'webpack.entry.js'), jsResult)
	} else {
		console.log(danger('ops generate error --'))
		console.log("")
		console.log(`\tregex ${danger(jsRegex)} did not match any lines in ${danger('webpack.entry.js')}.`)
		console.log(`\tplease add the following import statement manually:`)
		console.log(`\t${accent(jsImport)}`)
		console.log("")
		importErrors = true
	}

	if (!importErrors) console.log(`\n\t${primary(name)} is ready.\n`)
}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

module.exports = startGenerateService



// WEBPACK FOOTER //
// ./src/commands/generate/service.js